import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Funraise from './Funraise'
import { HomePage } from './HomePage';
import MedicalTreatment from "../Components/Modals/MedicalTreatment";
import Step2otp from "../Components/Modals/Step2otp"

import {Login} from "./Login/Login";

import { Fundraiser_2 } from '../Components/Fundraiser-components/Fundraiser_2';
import { Fundraiser_3 } from '../Components/Fundraiser-components/Fundraiser_3';
import ProductPage from './ProdPage';
import FundraiserDetails from './FundraiserDetails';
import Popup from '../Components/Popup';
import Payment from '../Components/Payment';
import Final from '../Components/Final';

export const MainRoute = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
       
      <Route path="/medical" element={<MedicalTreatment />} />
      <Route path="/medical2" element={<Step2otp />} />
      <Route path="/stepotp" element={<Fundraiser_2 />} />
       
      <Route path="/step3" element={<Fundraiser_3/>}/>
          <Route path="/fundraise" element={<Funraise/>}/>
      <Route path='/login' element={<Login />} />
      <Route path="/donate" element={<ProductPage />} />
      <Route path="/fundraiserDetails/:id" element={<FundraiserDetails />} />
      <Route path="/contribute" element={<Popup />} />
      <Route path="/payment" element={<Payment/>}/>
      <Route path="/final" element={<Final/>}/>

    </Routes>
  )
}
